import {
    CLEAR_FAQ_LIST,
    GET_FAQ_LIST,
    SEARCH_FAQ,
    SET_ACTIVE_FAQ_TYPE,
    SET_FAQ_LIST,
} from "../actions/availableActions";
import {
    ClearFaqListAction,
    GetFaqListAction,
    SearchFaqAction,
    SetActiveFaqTypeAction,
    SetFaqListAction,
} from "../../interfaces/store/actions/faq";
import {FaqState} from "../../interfaces/store/reducers/faq";
import {FaqTypeAll} from "../../utils/constants";

const initialState: FaqState = {
    list: [],
    searchValue: "",
    activeFaqType: FaqTypeAll,
};

type AvailableActions =
    GetFaqListAction
    | ClearFaqListAction
    | SearchFaqAction
    | SetFaqListAction
    | SetActiveFaqTypeAction;

const faqReducer = (state:FaqState = initialState, action: AvailableActions): FaqState => {
    switch (action.type) {
        case GET_FAQ_LIST:
            return {
                ...state,
            };
        case SEARCH_FAQ:
            return {
                ...state,
                searchValue: action.payload,
            };
        case SET_ACTIVE_FAQ_TYPE:
            return {
                ...state,
                activeFaqType: action.payload,
            };
        case SET_FAQ_LIST:
            return {
                ...state,
                list: action.payload,
            };
        case CLEAR_FAQ_LIST:
            return {
                ...state,
                list: [],
                searchValue: "",
            };
        default:
            return state;
    }
};

export default faqReducer;
